<template>
  <div class="boxall">
    <div class="page-head">
      <div class="title">价格走势</div>

      <span class="btn-container">
        <button class="detail-btn" @click="$emit('switchCenter')">
          {{ opened ? '返回' : '详情' }}
          <img src="../assets/images/more_arrow.png" alt="icon" />
        </button>
      </span>
    </div>

    <div class="boxnav">
      <!-- <div class="chart-container" id="priceChart"></div> -->
      <div class="bg-image"></div>
    </div>
  </div>
</template>

<script>
// import { getDashboardData } from '@/api/getData'
// import * as echarts from 'echarts'

export default {
  name: 'PriceTrend',

  props: {
    activeComp: {
      type: String,
      default: 'CenterMap'
    }
  },

  computed: {
    opened() {
      return this.activeComp === 'PriceDetail'
    }
  },

  // 1. 获取价格数据：采购/销售，采集日期（先使用mock data）
  // 2. 画两条折线图, y轴代表平均采购价格/平均销售价格, x轴采集日期

  data() {
    return {
      salePrice: [],

      buyPrice: [],

      goodsList: [],

      dateList: []
    }
  },

  // mounted() {
  //   this.initPriceTrendChart()
  // },

  created() {
    // this.fetchData()
  },

  methods: {
    /*  
    // 获取销售/采购价格数据
    async fetchData() {
      try {
        const res = await getDashboardData()
        // console.log(res)
        if (res.resultCode == 1) {
          this.buyPrice = res.resultInfo.price_list.sell_price
          this.salePrice = res.resultInfo.price_list.supply_price
          this.dateList = res.resultInfo.price_list.date_list
          this.goodsList = res.resultInfo.price_list.goods_list

          this.initPriceTrendChart()
        }
      } catch (err) {
        console.log(err)
      }
    },

    //========== 处理图表 ==========
    initPriceTrendChart() {
      if (!this.salePrice || this.salePrice.length === 0) return

      if (!this.buyPrice || this.buyPrice.length === 0) return

      // 1.初始化Echarts实例
      const chartDom = document.getElementById('priceChart')

      const myChart = echarts.init(chartDom)

      window.addEventListener('resize', () => {
        myChart.resize()
      })

      // 2. 从salePrice, buyPrice提取图表需要的数据
      // x轴： 采集日期
      // const xData = this.salePrice.map(item => item.date)
      const xData = this.dateList

      // y轴：每天不同采集点的平均销售价格/平均采购价格
      // const ySaleData = this.salePrice.map(item => item.price).reverse()
      // const yBuyData = this.buyPrice.map(item => item.price).reverse()

      const ySaleData = this.salePrice
      const yBuyData = this.buyPrice

      // 3. 配置参数
      const option = {
        grid: {
          top: '5%', // 距离顶部距离（给标题/单位留空间）
          left: '3%', // 距离左侧距离
          right: '5%', // 距离右侧距离
          bottom: '5%', // 距离底部距离
          containLabel: true // 包含坐标轴标签在内进行计算
        },
        tooltip: { trigger: 'axis' },

        xAxis: {
          type: 'category',
          data: xData,
          boundaryGap: false,
          //坐标轴线和标签颜色
          axisLabel: { color: 'rgba(255,255,255,0.7)', fontSize: 12 },
          axisLine: { lineStyle: { color: 'rgba(255,255,255,0.2)' } }
        },
        yAxis: {
          type: 'value',
          name: '￥/斤',
          nameTextStyle: { color: 'rgba(255,255,255,0.5)', fontSize: 10 },
          axisLabel: { color: 'rgba(255,255,255,0.7)', fontSize: 12 },

          axisLine: {
            lineStyle: { color: 'rgba(255,255,255,0.2)' },
            show: true,
            symbol: ['none', 'arrow'], // [起点, 终点] 箭头
            symbolSize: [8, 12], // [宽, 高]
            symbolOffset: [0, 10] // 箭头偏移量
          },

          // 分割线颜色淡一点
          splitLine: false
        },
        series: [
          {
            name: '销售价',
            type: 'line',
            data: ySaleData,
            smooth: true,
            // areaStyle: { color: 'rgba(67, 233, 123, 0.3)' }, // 区域填充颜色
            itemStyle: { color: '#43e97b' }, // 线条颜色
            lineStyle: {
              width: 3, // 默认通常为 2
              shadowBlur: 10
            },
            symbolSize: 2,
            // 柱子顶部数值标签
            label: {
              show: false,
              position: 'top',
              color: '#7ddfff',
              fontSize: 12,
              formatter: '{c}'
            }
          },
          {
            name: '采购价',
            type: 'line',
            data: yBuyData,
            smooth: true,
            itemStyle: { color: '#00d2ff' },
            lineStyle: { width: 3, shadowColor: 'rgba(0, 210, 255, 0.4)', shadowBlur: 10 },

            symbolSize: 2,
            // 柱子顶部数值标签
            label: {
              show: false,
              position: 'bottom',
              color: '#7ddfff',
              fontSize: 12,
              formatter: '{c}'
            }
          }
        ]
      }

      // 4. 绘图
      myChart.setOption(option)
    }
      */
  }
}
</script>

<style scoped>
.bg-image {
  width: 100%;
  height: 100%;
  background: url('../assets/images/price-bg.png') no-repeat center center;
  background-size: cover;
  border-radius: 12px;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.chart-container {
  height: 100%;
  width: 100%;
}

.page-head {
  position: relative;
}

.btn-container {
  position: absolute;
  top: 8px;
  right: 8px;
}

.detail-btn {
  background: #c7e9f600;
  padding: 2.4px 5px;
  color: #49d8ec;
  font-size: 12px;
  border-radius: 6.4px;
  border: 1.6px solid #49d8ec;
  box-shadow: 0 0 20px rgba(0, 191, 255, 0.4), inset 0 0 12px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);

  cursor: pointer;
}

.detail-btn img {
  height: 8px;
  width: 8px;
}
</style>
